import { render, staticRenderFns } from "./VideoPreviewModal.vue?vue&type=template&id=3ff520fe&scoped=true"
import script from "./VideoPreviewModal.vue?vue&type=script&lang=js"
export * from "./VideoPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./VideoPreviewModal.vue?vue&type=style&index=0&id=3ff520fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff520fe",
  null
  
)

export default component.exports